import { noticeUniappStore } from '@/utils';
const state = {
  userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
  token: localStorage.getItem('appToken') || '',
  collectList: JSON.parse(localStorage.getItem('collectList')) || [],
  collectData: JSON.parse(localStorage.getItem('collectData')) || {
    delList: [],
    addList: []
  },
  chargingStation: JSON.parse(localStorage.getItem('chargingStation')) || [],
  shopPois: JSON.parse(localStorage.getItem('shopPois')) || [],
  webUrl: localStorage.getItem('webUrl') || 'http://127.0.0.1:8030/static',
  userId: localStorage.getItem('userId') || '',
  userXdToken: localStorage.getItem('userXdToken') || '',
  lastNaviChargeId: Number(localStorage.getItem('lastNaviChargeId')) || 0
};
const mutations = {
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  },
  SET_USER_ID(state, userId) {
    state.userId = userId;
    localStorage.setItem('userId', userId);
  },
  SET_TOKEN(state, token) {
    state.token = token;
    localStorage.setItem('appToken', token);
  },
  SET_COLLECT_LIST(state, collectList) {
    state.collectList = collectList;
    localStorage.setItem('collectList', JSON.stringify(collectList));
  },
  SET_COLLECT_DATA(state, collectData) {
    state.collectData = collectData;
    localStorage.setItem('collectData', JSON.stringify(collectData));
    noticeUniappStore('collectData', collectData);
  },
  SET_CHARGING_STATION(state, chargingStation) {
    state.chargingStation = chargingStation;
    localStorage.setItem('chargingStation', JSON.stringify(chargingStation));
  },
  SET_SHOP_POIS(state, shopPois) {
    state.shopPois = shopPois;
    // console.log('shopPois =', JSON.stringify(shopPois))
    localStorage.setItem('shopPois', JSON.stringify(shopPois));
  },
  SET_WEB_URL(state, webUrl) {
    state.webUrl = webUrl;
    localStorage.setItem('webUrl', webUrl);
  },
  SET_USER_XD_TOKEN(state, userXdToken) {
    state.userXdToken = userXdToken;
    localStorage.setItem('userXdToken', userXdToken);
  },
  SET_LAST_NAVI_CHARGE_ID(state, lastNaviChargeId) {
    var _window, _window$android;
    state.lastNaviChargeId = lastNaviChargeId;
    localStorage.setItem('lastNaviChargeId', lastNaviChargeId);
    (_window = window) === null || _window === void 0 ? void 0 : (_window$android = _window.android) === null || _window$android === void 0 ? void 0 : _window$android.setLastNaviChargeId(JSON.stringify({
      chargeId: lastNaviChargeId
    }));
  }
};
const actions = {
  // 设置用户信息
  setUserInfo({
    commit
  }, userInfo) {
    commit('SET_USER_INFO', userInfo);
  },
  setUserId({
    commit
  }, userId) {
    commit('SET_USER_ID', userId);
  },
  setUserXdToken({
    commit
  }, userXdToken) {
    commit('SET_USER_XD_TOKEN', userXdToken);
  },
  setLastNaviChargeId({
    commit
  }, lastNaviChargeId) {
    commit('SET_LAST_NAVI_CHARGE_ID', lastNaviChargeId);
  },
  // 设置token
  setToken({
    commit
  }, token) {
    commit('SET_TOKEN', token);
  },
  // 设置收藏列表
  setCollectList({
    commit
  }, collectList) {
    commit('SET_COLLECT_LIST', collectList);
  },
  // 设置收藏数据 用于维护
  setCollectData({
    commit
  }, collectData) {
    commit('SET_COLLECT_DATA', collectData);
  },
  // 存储充电桩数据
  setChargingStation({
    commit
  }, chargingStation) {
    commit('SET_CHARGING_STATION', chargingStation);
  },
  // 设置商铺数据
  setShopPois({
    commit
  }, shopPois) {
    commit('SET_SHOP_POIS', shopPois);
  },
  // 设置本地服务url数据
  setWebUrl({
    commit
  }, webUrl) {
    commit('SET_WEB_URL', webUrl);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};